// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { Link, withRouter } = require('react-router-dom');
const classnames = require('classnames');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { find, get, filter, startsWith } = require('lodash');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const MortgageRequestDataProprietorBodyItem = require('./mortgageRequestDataProprietorBodyItem/mortgageRequestDataProprietorBodyItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
const Message = require('./message');

// @ actions
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');

// @ constants
const { DOCUMENTS_STATUS, EMPLOYMENT_SITUATION } = require('constants/mortgageRequestHolderData');
const documentsTypes = require('constants/mortgageRequestDocumentsTypes');
const maxProprietor = 2;
const mortgageRequestStates = require('constants/mortgageRequestStates');
class MortgageRequestDataProprietor extends React.Component {
    constructor(props) {
        super(props);

        const { summaryDocumentation, mortgageRequestState, isExpandedDataProprietor } = this.props;

        this.state = {
            isExpanded: isExpandedDataProprietor
        };

        this.idExpediente = mortgageRequestState.get('idExpediente') || 0;
        this.documentationList = summaryDocumentation.get('data', []);
        this.documentationListParse = this.documentationList.toJS();
        this.proprietors = null;

        this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
        this.handleOnClickAddProprietor = this.handleOnClickAddProprietor.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.buildStatusStep = this.buildStatusStep.bind(this);
        this.buildButtonAddProprietor = this.buildButtonAddProprietor.bind(this);
        this.buildItem = this.buildItem.bind(this);
        this.isReady = this.isReady.bind(this);

        this.isReadyPromise = new Promise(resolve => {
            this.resolveIsReady = resolve;
        });
    }

    componentWillReceiveProps(nextProps) {
        const nextDocumentationList = nextProps.summaryDocumentation.get('data', []);
        const nextDocumentationListParse = nextDocumentationList.toJS();
        if (
            !!nextDocumentationListParse &&
            nextDocumentationListParse.length !== this.documentationListParse.length
        ) {
            this.documentationListParse = nextDocumentationListParse;
        }
    }

    componentDidUpdate() {
        const { dataProprietors } = this.props;
        this.proprietors = dataProprietors.get('data').count();

        if (!dataProprietors.get('isFetching')) {
            this.resolveIsReady();
        }
    }

    getDocumentStatus(documentsTypeList, idHolderDocumentNumber = '') {
        let documentData;
        let documentDataStatus;
        for (let i = 0; documentsTypeList[i]; i++) {
            documentData = find(
                this.documentationListParse,
                doc =>
                    doc.tipoDocumentoId === documentsTypeList[i] &&
                    (!idHolderDocumentNumber || doc.numeroDocumento === idHolderDocumentNumber)
            );
            documentDataStatus =
                get(documentData, 'estado', DOCUMENTS_STATUS.NONE) || DOCUMENTS_STATUS.NONE;

            if (
                documentDataStatus !== DOCUMENTS_STATUS.PEND_APORTAR &&
                documentDataStatus !== DOCUMENTS_STATUS.NONE
            ) {
                break;
            }
        }
        return documentDataStatus;
    }

    getStatus(fileStatus1, fileStatus2) {
        if (fileStatus1 === fileStatus2) {
            return fileStatus1;
        } else if (fileStatus1 === DOCUMENTS_STATUS.NO_VALIDO || fileStatus2 === DOCUMENTS_STATUS.NO_VALIDO) {
            return DOCUMENTS_STATUS.NO_VALIDO;
        } else if (
            (fileStatus1 === DOCUMENTS_STATUS.NONE || fileStatus1 === DOCUMENTS_STATUS.PEND_APORTAR) ||
            (fileStatus2 === DOCUMENTS_STATUS.NONE || fileStatus2 === DOCUMENTS_STATUS.PEND_APORTAR)
        ) {
            return DOCUMENTS_STATUS.NONE;
        } else if (fileStatus1 === DOCUMENTS_STATUS.PEND_VAL || fileStatus2 === DOCUMENTS_STATUS.PEND_VAL) {
            return DOCUMENTS_STATUS.PEND_VAL;
        }
    }

    buildButtonAddProprietor() {
        const { dataProprietors } = this.props;
        const dataProprietorAddBtn = formatText('mortgageRequestPanel-dataProprietorAddBtn');
        this.proprietors = dataProprietors.get('data').count();
        const personalData = dataProprietors.get('personalData');
        const isCheckedCirbe = personalData.some(person => person?.checkCirbe === 1);
        const operationProcessId = personalData.find(person => person?.operationProcessId)?.operationProcessId;
        if (this.proprietors < maxProprietor) {
            return (
                <OKButton
                    modifier="ghost"
                    leftIcon="icon-agregar"
                    onClick={this.handleOnClickAddProprietor}
                    disabled={ isCheckedCirbe || (!isCheckedCirbe && operationProcessId) }
                >
                    {dataProprietorAddBtn}
                </OKButton>
            );
        }
    }

    buildItem(dataProprietor, index) {
        const {
            dataProprietorsDelete,
            deleteDataProprietor,
            setProprietorId,
            requestDataProprietor,
            isApprovedDataProprietor,
            mortgageRequestState,
            holdersDataValidation,
            currentState,
            dataProprietors
        } = this.props;
        
        const personalData = dataProprietors.get('personalData');
        const isCheckedCirbe = personalData.some(person => person?.checkCirbe === 1);
        const personWithOperationProcessId = personalData.find(person => person?.operationProcessId);
        const operationProcessId = personWithOperationProcessId ? personWithOperationProcessId.operationProcessId : undefined;
        const proprietorNumValue = dataProprietor.get('numeroTitular', '');
        const numclienteobcdValue = dataProprietor.get('numclienteobcd', '');
        const proprietorDocumentTypeValue = dataProprietor.getIn(
            ['datosPersonales', 'documentoDeIdentidad', 'tipoDocumentoIdentidad'],
            ''
        );
        const proprietorDocumentIdValue = dataProprietor.getIn(
            ['datosPersonales', 'documentoDeIdentidad', 'identificador'],
            ''
        );
        const employmentSituationValue = dataProprietor.getIn(
            ['datosEmpleo', 'situacionLaboral'],
            ''
        );
        const laboralLifeTypeList = [documentsTypes.NOM_VL, documentsTypes.VL, documentsTypes.NOM];
        const irpf100TypeList = [documentsTypes.IRPF100, documentsTypes.IRPF100_CLI];
        const irpf130LifeTypeList = [documentsTypes.IRPF130];
        const ceaInfo = {
            idCea: dataProprietor.getIn(['datosEmpleo', 'idCea'], ''),
            fechaGenCea: dataProprietor.getIn(['datosEmpleo', 'fechaGenCea'], ''),
            codigoCea: filter(dataProprietor.get('datosEmpleo', {}).toJS(), (code, key) =>
                startsWith(key, 'codigoCea')
            )
        };
        const documentLaboralLifeValue = this.getDocumentStatus(
            laboralLifeTypeList,
            proprietorDocumentIdValue
        );
        const documentIrpf100Value = this.getDocumentStatus(
            irpf100TypeList,
            proprietorDocumentIdValue
        );
        const documentIrpf130Value = this.getDocumentStatus(
            irpf130LifeTypeList,
            proprietorDocumentIdValue
        );
        const hideLinks = proprietorNumValue === 2 && currentState === mortgageRequestStates.CONFIRMA_DATOS_T2;
        let documentIrpfValue;

        if (employmentSituationValue === EMPLOYMENT_SITUATION.AUTONOMO) {
            documentIrpfValue = this.getStatus(documentIrpf100Value, documentIrpf130Value);
        } else {
            documentIrpfValue = documentIrpf100Value;
        }

        const holderKey = proprietorNumValue === 2 ? 'isCoHolder' : 'isHolder';
        const stepsValidation = holdersDataValidation.getIn([holderKey, 'stepsValidation']);
        const stepsRoutes = holdersDataValidation.getIn([holderKey, 'stepsRoutes']);

        return proprietorDocumentIdValue && (
            <MortgageRequestDataProprietorBodyItem
                key={index}
                idExpediente={this.idExpediente}
                currentState={currentState}
                proprietorNum={proprietorNumValue}
                numclienteobcd={numclienteobcdValue}
                proprietorDocumentType={proprietorDocumentTypeValue}
                proprietorDocumentId={proprietorDocumentIdValue}
                employmentSituation={employmentSituationValue}
                documentLaboralLife={documentLaboralLifeValue}
                ceaInfo={ceaInfo}
                documentIrpf={documentIrpfValue}
                onRequestDataProprietor={requestDataProprietor}
                onDelete={deleteDataProprietor}
                onSet={setProprietorId}
                dataProprietorsDelete={dataProprietorsDelete}
                isApprovedDataProprietor={isApprovedDataProprietor}
                mortgageRequestState={mortgageRequestState}
                hideLinks={hideLinks}
                stepsValidation={stepsValidation}
                stepsRoutes={stepsRoutes}
                isCheckedCirbe={isCheckedCirbe}
                operationProcessId={operationProcessId}
            />
        );
    }

    buildStatusStep(classNameValue) {
        const { isApprovedDataProprietor } = this.props;
        let elementStatus = (
            <span className="mortgage-request-manager-panel-steps__ico--step-approved" />
        );

        if (isApprovedDataProprietor) {
            elementStatus = <h2 className={classNameValue}>1</h2>;
        }

        return elementStatus;
    }

    handleOnClickAccordion() {
        if (this.state.isExpanded) {
            this.setState({ isExpanded: false });
        } else {
            this.setState({ isExpanded: true });
        }
    }

    handleOnClickAddProprietor(evt) {
        evt && evt.preventDefault();
        const { isClientWithoutAccounts, mortgageRequestState } = this.props;
        (mortgageRequestState.get('estado') === mortgageRequestStates.APORTAR_DOC
            && isClientWithoutAccounts)
            ? this.props.history.push('/myprofile/mortgage/add-co-holder-info')
            : this.props.history.push('/myprofile/mortgage/co-holder-info');
    }

    isReady() {
        return this.isReadyPromise;
    }

    render() {
        const {
            isExpandedDataProprietor,
            isApprovedDataProprietor,
            dataProprietors,
            dataProprietorsDelete,
            mortgageRequestState,
            isClientWithoutAccounts,
            immHolderConfirmState
        } = this.props;

        const dataProprietorTitle = formatText('mortgageRequestPanel-dataProprietorTitle');
        const dataProprietorSubTitle = formatText('mortgageRequestPanel-dataProprietorSubTitle');

        const itemActive = classnames('step-item-num', {
            'step-item-num--active': this.state.isExpanded
        });

        let statusConfirmData;
        if(!immHolderConfirmState.get('completeHoldersData')) {
            statusConfirmData = (
                <FormattedText
                    value="mortgageRequestPanel-mortgageRequestPanel_dataProprietorDataConfirmMessage"
                    className="mortgage-request-manager-panel-steps__data-propietor__check-confirm-data-message" />
            );
        }

        const dataProprietorConfirm = isClientWithoutAccounts
            ? 'mortgageRequestPanel-dataProprietorDataConfirm'
            : 'mortgageRequestPanel-mortgageRequestPanel_clientDataProprietorDataConfirm'

        const getButtonAddProprietor = (isApprovedDataProprietor
            && mortgageRequestState.get('estado') !== mortgageRequestStates.CONFIRMA_DATOS_T2)
            ? this.buildButtonAddProprietor()
            : '';
        const getStatusStep = this.buildStatusStep(itemActive);
        const dataProprietorList = dataProprietors.get('data');
        const dataProprietorElement = dataProprietorList.map(this.buildItem);
        const isFetchingDataProprietors = dataProprietors.get('isFetching');
        const isFetchingDataProprietorsDelete = dataProprietorsDelete.get('isFetching');

        if ((isFetchingDataProprietors || isFetchingDataProprietorsDelete) && isExpandedDataProprietor) {
            return (
                <div className="row step-item">
                    <LoadingSection />
                </div>
            );
        }

        let dataConfirmElement = '';

        if (isApprovedDataProprietor) {
            if (mortgageRequestState.get('estado') === mortgageRequestStates.CONFIRMA_DATOS_T2) {
                dataConfirmElement = (
                    <div className="mortgage-request-manager-panel-steps__waiting-data-confirmation">
                        <OKMessage type="warning">
                            <FormattedText value="mortgageRequestPanel-dataProprietorWitingDataConfirmation" />
                        </OKMessage>
                    </div>
                );
            } else {
                dataConfirmElement = (
                    <ul className="list-unstyled mortgage-request-manager-panel-steps__list">
                        <li>
                            <div className="row">
                                <div className="col-xs-12">
                                    <h4><FormattedText value={dataProprietorConfirm} /></h4>
                                    {statusConfirmData}
                                </div>
                                <Link
                                    to="/myprofile/mortgage/holder-data-confirmation"
                                >
                                    <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente" />
                                </Link>
                            </div>
                        </li>
                    </ul>
                );
            }
        }

        return (
            <div className="row step-item">
                <div className="col-xs-1">
                    {getStatusStep}
                </div>
                <div className="col-xs-11">
                    <Accordion
                        customClassName="mortgage-request-manager-panel-steps__collapsable"
                        isExpanded={isExpandedDataProprietor}
                        id="stepDataProprietor"
                        onClick={this.handleOnClickAccordion}
                    >
                        <AccordionHeader name="AccordionHeader" isRightArrowPosition={true}>
                            <h3>
                                {dataProprietorTitle}
                            </h3>
                            <p>
                                {dataProprietorSubTitle}
                            </p>
                        </AccordionHeader>

                        <AccordionBody name="AccordionBody">
                            {getButtonAddProprietor}
                            {dataProprietorElement}
                            <div className="mortgage-request-manager-panel-steps__footer">
                                {dataConfirmElement}
                                <div className="content-message">
                                    <Message/>
                                </div>
                            </div>
                        </AccordionBody>
                    </Accordion>
                </div>
            </div>
        );
    }
}

MortgageRequestDataProprietor.propTypes = {
    isExpandedDataProprietor: PropTypes.bool,
    isClientWithoutAccounts: PropTypes.bool,
    isApprovedDataProprietor: PropTypes.bool,
    summaryDocumentation: PropTypes.object,
    dataProprietors: PropTypes.object,
    dataProprietorsDelete: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    requestDataProprietor: PropTypes.func,
    deleteDataProprietor: PropTypes.func,
    setProprietorId: PropTypes.func,
    currentState: PropTypes.string,
    immHolderConfirmState: PropTypes.object,
    holdersDataValidation: PropTypes.object,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MortgageRequestDataProprietor;
module.exports.MortgageRequestDataProprietor = withRouter(connect(
    state => ({
        summaryDocumentation: state.mortgageRequestSummaryDocumentation,
        dataProprietors: state.mortgageRequestDataProprietor,
        dataProprietorsDelete: state.mortgageRequestDataProprietorDelete,
        mortgageRequestState: state.mortgageRequestState,
        holdersDataValidation: state.mortgageHoldersDataValidation
    }),
    {
        requestDataProprietor: dataProprietorActions.requestDataProprietor,
        deleteDataProprietor: dataProprietorActions.deleteDataProprietor,
        setProprietorId: dataProprietorActions.setProprietorId
    },
    null,
    { forwardRef: true }
)(MortgageRequestDataProprietor));
